import { Component } from '@angular/core';
import { App, NavController, NavParams, ViewController, ModalController } from 'ionic-angular';

import { TabsPage } from '../employee/tabs/tabs';
import { SignupPage } from '../signup/signup';
import { DashboardPage } from '../employer/dashboard/dashboard';
import { Storage } from '@ionic/storage'
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastController } from 'ionic-angular';



import {AuthProvider} from '../../providers/auth/auth'
import { RhDashboardPage } from '../employee/_rh/dashboard/rh-dashboard';
import { TabsPageRh } from '../employee/tabsRh/tabsRh';



@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  constructor(public app: App, public navCtrl: NavController,
     public navParams: NavParams,
     public viewCtrl: ViewController,
     public modalCtrl: ModalController,
     public authProvider: AuthProvider,
     private storage: Storage,
     private helper: JwtHelperService,
     private toastCtrl: ToastController) {
  }

  // Form values
  login: any = {user: '', pwd: ''};
  loggedIn:boolean

  // Login error toast
  toast:any = this.toastCtrl.create({
    message: 'Identifiants invalides',
    duration: 3000,
    position: 'top'
  });

  ionViewDidLoad() {
    this.storage.get("access_token").then((res) =>{
      if(res){
        this.proceedLogin(res)
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  proceedLogin(token){ // Loading front according to if employee or employer

    this.authProvider.user = this.helper.decodeToken(token);

         if(this.authProvider.user.options.settings_social_network_enabled == false){
          this.dismiss();
          this.app.getRootNav().setRoot(TabsPageRh)
            .then(() => {

            })
         }
         else{
          this.dismiss();
          this.app.getRootNav().setRoot(TabsPage)
            .then(() => {})
         }

  }

  loginForm() {

    this.authProvider.userLogin(this.login.user, this.login.pwd).subscribe(
      res => {
          if(res.success){
          const token = res.data['token'];
          this.authProvider.user = this.helper.decodeToken(token);

          if(this.authProvider.user.email == this.login.user.toLowerCase()){
            this.storage.set("access_token", token);
            this.authProvider.authenticationState.next(true);
            this.proceedLogin(token)
          }
        }else{
          this.toast.present();
        }
       },
       (err) => {
        this.toast.present();

        }
     );

  }

  goToDashboard() {

  }



  goToSignup() {
    this.viewCtrl.dismiss();
    let modal = this.modalCtrl.create(SignupPage, {}, {cssClass: 'modal-gradient'});
    modal.present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts